import { Element } from 'shared/core';

export class ScreenDetailsElement extends Element {
  public init(): void {
    const screenDetailsField = document.getElementById('screen_details') as HTMLInputElement;

    if (screenDetailsField) {
      const screenResolution = `${window.screen.width}x${window.screen.height}`;
      const viewportSize = `${window.innerWidth}x${window.innerHeight}`;
      screenDetailsField.value = `screen_resolution:${screenResolution},viewport_size:${viewportSize}`;
    }
  }
}
